import React from "react";
import BgSection3 from "./images/section3-bg.png"; // นำเข้าภาพ section2-bg

const Section3 = () => {
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-full h-1/4">
        <img
          src={BgSection3}
          alt="Missy Kim Background"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default Section3;
